module.exports = __webpack_public_path__ + "static/banner-footer-update-data-cl-c57fa68d949a45d827c0e6034761658b.png";